import { useState } from 'react';
import { Stack, Text } from '@fluentui/react';
import { useAtomValue } from 'jotai';
import { profileDataAtom } from '../../atoms/authAtoms';
import { appRoles } from '../../authConfig';
import GlobalPricingParameterPanel from './GlobalPricingParameterPanel';
import PricingParameterLoadError from './PricingParameterLoadError';
import PricingParameterScopeBar from './PricingParameterScopeBar';
import {
  emptyParameterQuery,
  queryPricingItemId,
} from './pricingParameterHelpers';
import { usePricingParameterCatalog } from './usePricingParameterCatalog';

const GlobalPricingParameters = () => {
  const { roles } = useAtomValue(profileDataAtom);
  const isAdmin = roles.includes(appRoles.Admin);
  const catalog = usePricingParameterCatalog();
  const [query, setQuery] = useState(emptyParameterQuery);
  const pricingItemId = queryPricingItemId(query);

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Text>
        A global value applies to every tenant that has no override for the same
        parameter on the same dates. Rates are managed in Pricing rates.
      </Text>
      <PricingParameterScopeBar
        catalog={catalog}
        query={query}
        onChange={setQuery}
      />
      <PricingParameterLoadError error={catalog.error} />
      {pricingItemId === undefined ? (
        <Text>Select a pricing item to manage its global parameters.</Text>
      ) : (
        <GlobalPricingParameterPanel
          key={pricingItemId}
          isAdmin={isAdmin}
          catalog={catalog}
          pricingItemId={pricingItemId}
        />
      )}
    </Stack>
  );
};

export default GlobalPricingParameters;
